import { render, staticRenderFns } from "./subspace-manage.vue?vue&type=template&id=2bb94cf9&scoped=true"
import script from "./subspace-manage.vue?vue&type=script&lang=js"
export * from "./subspace-manage.vue?vue&type=script&lang=js"
import style0 from "./subspace-manage.vue?vue&type=style&index=0&id=2bb94cf9&prod&lang=less&scoped=true"
import style1 from "./subspace-manage.vue?vue&type=style&index=1&id=2bb94cf9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb94cf9",
  null
  
)

export default component.exports